import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import referralActions from '../../../../store/analyticsStores/referralStore/referralActions';
import referralCodesActions from '../../../../store/analyticsStores/referralCodesStore/referralCodesActions';
import ReferralAnalytics from './components/ReferralAnalytics/ReferralAnalytics';
import { PENDING } from '../../../../store/globalStatuses/globalStatuses';

export default function ReferralAnalyticsContainer() {
    const dispatch = useDispatch();
    const { analytics, status } = useSelector(state => state.referralReducer);
    const codesState = useSelector(state => state.referralCodesReducer);
    const { info } = useSelector(state => state.branchReducer);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [phoneInput, setPhoneInput] = useState('');
    const debounceRef = useRef(null);

    useEffect(() => {
        if (info?.id) {
            let dates = '';
            if (startDate && endDate) {
                dates = `?from=${startDate.getTime()}&to=${endDate.getTime()}`;
            }
            dispatch(referralActions.getReferralAnalytics(info.id, dates));
        }
    }, [info?.id, startDate, endDate, dispatch]);

    const fetchCodes = useCallback((overrides = {}) => {
        if (!info?.id) return;
        const params = {
            phone: overrides.phone !== undefined ? overrides.phone : codesState.params.phone,
            limit: codesState.params.limit,
            after: overrides.after || '',
            before: overrides.before || '',
        };
        dispatch(referralCodesActions.setParams(params));
        dispatch(referralCodesActions.getReferralCodes(info.id, params));
    }, [info?.id, dispatch, codesState.params.phone, codesState.params.limit]);

    useEffect(() => {
        if (info?.id) {
            dispatch(referralCodesActions.reset());
            dispatch(referralCodesActions.getReferralCodes(info.id, { phone: '', limit: 20 }));
            setPhoneInput('');
        }
    }, [info?.id, dispatch]);

    const handlePhoneChange = (value) => {
        setPhoneInput(value);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            fetchCodes({ phone: value, after: '', before: '' });
        }, 300);
    };

    const handleNext = () => {
        if (codesState.pagination?.next_cursor) {
            fetchCodes({ after: codesState.pagination.next_cursor });
        }
    };

    const handlePrev = () => {
        if (codesState.pagination?.prev_cursor) {
            fetchCodes({ before: codesState.pagination.prev_cursor });
        }
    };

    return (
        <ReferralAnalytics
            analytics={analytics}
            isLoading={status === PENDING}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            codesItems={codesState.items}
            codesPagination={codesState.pagination}
            codesLoading={codesState.status === PENDING}
            phoneInput={phoneInput}
            onPhoneChange={handlePhoneChange}
            onNextPage={handleNext}
            onPrevPage={handlePrev}
        />
    );
}
